import { IconClose } from '@costar-ui/icons/csg/IconClose';
import React, { useCallback } from 'react';
import { chain } from 'react-aria';
import { defaultModalScrollBarId } from './default-modal-scroll-bar-id.esm.js';
import Button from '../../button/button.esm.js';
import Card from '../../card/card.esm.js';
import Heading from '../../text/heading.esm.js';

function AlertDialogLayout(props) {
  var _props$title = props.title,
    title = _props$title === void 0 ? ' ' : _props$title,
    _props$slots = props.slots,
    slots = _props$slots === void 0 ? {} : _props$slots,
    showCloseIcon = props.showCloseIcon,
    hideFooter = props.hideFooter,
    cancelLabel = props.cancelLabel,
    actionLabel = props.actionLabel,
    onAction = props.onAction,
    onCancel = props.onCancel,
    onClose = props.onClose,
    children = props.children,
    _props$scrollBarId = props.scrollBarId,
    scrollBarId = _props$scrollBarId === void 0 ? defaultModalScrollBarId : _props$scrollBarId,
    _props$classNames = props.classNames,
    classNames = _props$classNames === void 0 ? {} : _props$classNames;
  var leftHeader = slots.leftHeader,
    rightHeader = slots.rightHeader,
    leftFooter = slots.leftFooter,
    rightFooter = slots.rightFooter;
  var _classNames$root = classNames.root,
    rootClassName = _classNames$root === void 0 ? '' : _classNames$root,
    _classNames$body = classNames.body,
    bodyClassName = _classNames$body === void 0 ? '' : _classNames$body,
    _classNames$header = classNames.header,
    headerClassName = _classNames$header === void 0 ? '' : _classNames$header,
    _classNames$footer = classNames.footer,
    footerClassName = _classNames$footer === void 0 ? '' : _classNames$footer,
    _classNames$leftFoote = classNames.leftFooterWrapper,
    leftFooterWrapperClassname = _classNames$leftFoote === void 0 ? '' : _classNames$leftFoote,
    _classNames$rightFoot = classNames.rightFooterWrapper,
    rightFooterWrapperClassName = _classNames$rightFoot === void 0 ? '' : _classNames$rightFoot;
  var handleClose = useCallback(function () {
    return onClose && onClose();
  }, [onClose]);
  var includeHeader = title.trim() || rightHeader || showCloseIcon;
  return /*#__PURE__*/React.createElement(Card, {
    className: rootClassName,
    withDivider: true,
    fullWidth: true,
    bordered: false
  }, includeHeader && /*#__PURE__*/React.createElement(Card.Header, {
    className: headerClassName
  }, /*#__PURE__*/React.createElement(Card.Slot, {
    justify: "start",
    gap: "md"
  }, title.trim() && /*#__PURE__*/React.createElement(Heading, {
    slot: "title",
    variant: "heading-18"
  }, title), leftHeader), (rightHeader || showCloseIcon) && /*#__PURE__*/React.createElement(Card.Slot, {
    justify: "end",
    gap: "md"
  }, rightHeader, showCloseIcon && /*#__PURE__*/React.createElement(Button, {
    variant: "ghost-neutral",
    size: "icon-sm",
    onPress: handleClose
  }, /*#__PURE__*/React.createElement(IconClose, {
    className: "text-action-neutral"
  })))), /*#__PURE__*/React.createElement(Card.Body, {
    className: bodyClassName,
    canShrink: true,
    scrollable: true,
    id: scrollBarId
  }, children), !hideFooter && /*#__PURE__*/React.createElement(Card.Footer, {
    className: footerClassName,
    justify: !leftFooter ? 'end' : undefined
  }, leftFooter && /*#__PURE__*/React.createElement(Card.Slot, {
    justify: "start",
    gap: "md",
    className: leftFooterWrapperClassname
  }, leftFooter), /*#__PURE__*/React.createElement(Card.Slot, {
    justify: "end",
    gap: "md",
    className: rightFooterWrapperClassName
  }, rightFooter, onCancel && /*#__PURE__*/React.createElement(Button, {
    variant: "secondary",
    onPress: chain(onCancel, handleClose)
  }, cancelLabel || 'Cancel'), onAction && /*#__PURE__*/React.createElement(Button, {
    variant: 'primary',
    autoFocus: true,
    onPress: chain(onAction, handleClose)
  }, actionLabel || 'OK'))));
}

export { AlertDialogLayout as default };
//# sourceMappingURL=alert-dialog.esm.js.map
